import { render, staticRenderFns } from "./RelaseResSetting.vue?vue&type=template&id=657f7b66"
import script from "./RelaseResSetting.vue?vue&type=script&lang=js"
export * from "./RelaseResSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports